import React, { useState } from 'react';
import { getAlertColor } from '../../utils/weatherUtils';
import './AlertsBanner.css';

function AlertsBanner({ alerts }) {
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState([]);

  if (!alerts || alerts.length === 0) return null;

  const visibleAlerts = alerts.filter((_, i) => !dismissed.includes(i));

  if (visibleAlerts.length === 0) return null;

  const severityOrder = ['Extreme', 'Severe', 'Moderate', 'Minor'];
  const sortedAlerts = [...visibleAlerts].sort(
    (a, b) => severityOrder.indexOf(a.severity) - severityOrder.indexOf(b.severity)
  );

  const primaryAlert = sortedAlerts[0];

  return (
    <div className="alerts-banner" style={{ '--alert-color': getAlertColor(primaryAlert.severity) }}>
      <div className="alert-header" onClick={() => setExpanded(!expanded)}>
        <div className="alert-icon">
          <span className="warning-icon">⚠️</span>
          <span className="alert-count">{visibleAlerts.length}</span>
        </div>
        
        <div className="alert-summary">
          <span className="alert-title">{primaryAlert.event}</span>
          <span className="alert-headline">{primaryAlert.headline}</span>
        </div>

        <div className="alert-actions">
          <span className={`severity-badge ${primaryAlert.severity.toLowerCase()}`}>
            {primaryAlert.severity}
          </span>
          <button className="expand-btn">
            {expanded ? '▲' : '▼'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="alerts-list">
          {sortedAlerts.map((alert, index) => (
            <div key={alert.id || index} className="alert-item">
              <div className="alert-item-header">
                <span className="alert-event">{alert.event}</span>
                <span className={`severity-badge ${alert.severity.toLowerCase()}`}>
                  {alert.severity}
                </span>
              </div>
              <p className="alert-description">{alert.description}</p>
              {alert.instruction && (
                <p className="alert-instruction">{alert.instruction}</p>
              )}
              <button
                className="dismiss-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setDismissed([...dismissed, alerts.indexOf(alert)]);
                }}
              >
                Dismiss
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AlertsBanner;
